import { MyContext } from "../../../pages/Funnel";
import React, { useContext } from "react";

const Card = ({
  name,
  image,
  location,
  department,
  university,
  title,
  designation,
}) => {
  const key = ["Dept", "University", "Location"];
  const list = [department, university, location];

  const { state: details } = useContext(MyContext);

  return (
    <div className="shadow-xl">
      <div className="bg-white mt-14 text-center rounded-t-md">
        <img
          className="w-28 h-28 rounded-full object-cover absolute top-0 left-[50%] -translate-x-[50%] max-sm:w-24 max-sm:h-24"
          src={image}
          alt="img"
        />
        <h5 className="text-textColorSecondary font-medium text-lg mt-8 pt-20 max-sm:text-base max-sm:pt-16">
          {name}
        </h5>
        <h6 className="text-textColorSecondary font-medium text-lg mt-4 pb-8">
          {designation}
        </h6>
      </div>
      <ul
        style={{ backgroundColor: details.color }}
        className="bg-primary py-8 px-6 space-y-3 rounded-b-md">
        {list.map((val, index) => {
          return (
            <li className="text-white text-sm" key={index}>
              {" "}
              <span>{key[index]}</span> :{" "}
              <span className="font-light">{val}</span>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default Card;
